import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  errorHandler,
  formatDateMomentMonthFirst,
  showToast,
} from "../../../helper-methods";
// add note Modal
const AddNotesModal = ({
  type = undefined,
  isOpen,
  data,
  toggle,
  onSaveNotes,
}) => {
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  // reset state
  const _resetStateModal = () => {
    setNote("");
    setLoading(false);
  };

  // close function
  const _closeModal = () => {
    _resetStateModal();
    toggle();
  };

  // change notes field
  const _onChangeNotes = (value) => {
    setNote(value);
  };

  useEffect(() => {
    if (isOpen && data) {
      if (type === "signingCompany_AgentPayPeriodBreakdown") {
        if (data?.notes) setNote(data?.notes || "");
      } else {
        if (
          data.hasOwnProperty("payPeriodPaymentNotesClient") &&
          data.payPeriodPaymentNotesClient
        ) {
          // set note data if payPeriodPaymentNotesClient is find
          setNote(data?.payPeriodPaymentNotesClient);
        } else {
          if (data.notes) setNote(data?.notes);
        }
      }
    }
    // on open and on change of data value this is called
  }, [isOpen, data, type]);

  // save note
  const _onSaveNotes = async () => {
    try {
      setLoading(true);
      // call parent function
      await onSaveNotes(data?.id, note?.trim() || "");

      _closeModal();

      // dont show this toast if type === "signingCompany_AgentPayPeriodBreakdown", as for that case will show toaster from there only
      if (type !== "signingCompany_AgentPayPeriodBreakdown")
        showToast("Notes updated", "success");
    } catch (error) {
      setLoading(false);
      errorHandler(error);
    }
  };

  const _createPaymentHistoryNote = (item) => {
    // console.log("item _createPaymentHistoryNote >>", item);

    const {
      paymentAmount,
      referenceNumber,
      // checkDate,
      paymentMethod,
      cardBrand,
      cardLastFourDigit,
      processingFee,
      primaryAgentshare,
    } = item;

    // const formattedDate = checkDate
    //   ? `on ${formatDateMomentMonthFirst(checkDate)}`
    //   : "";
    const paymentMethodDetails =
      paymentMethod === "card"
        ? `via ${cardBrand} card ending in ${cardLastFourDigit}`
        : referenceNumber
        ? `via check#${referenceNumber}`
        : "";

    return (
      <div style={{ color: "#1B2430", marginBottom: 5 }}>
        <p>
          ${paymentAmount} agent fee was paid {paymentMethodDetails}
        </p>
        {processingFee?.amount ? (
          <p>Convenience Fee of ${processingFee.amount} was charged.</p>
        ) : null}
        {primaryAgentshare && (
          <p>
            ${primaryAgentshare.amount} was paid to agent{" "}
            {primaryAgentshare.name}.
          </p>
        )}
      </div>
    );
  };

  // console.log("data?.paymentHistory >>", data);

  return (
    <Modal isOpen={isOpen} toggle={_closeModal} centered scrollbar>
      <ModalHeader toggle={_closeModal}>Notes</ModalHeader>
      <ModalBody>
        <FormGroup className="floatingLabel">
          <Input
            type="textarea"
            rows="5"
            placeholder=" "
            value={note}
            onChange={(e) => _onChangeNotes(e.target.value)}
          />
          <Label> {data?.paymentHistory ? "Description" : "Notes"}</Label>
        </FormGroup>
        {type && type === "signingCompany_AgentPayPeriodBreakdown" ? (
          data?.payPeriodPaymentNotes ? (
            <Card>
              <CardHeader>Payment History</CardHeader>
              <CardBody>
                <div style={{ color: "#1B2430" }}>
                  <p>{data?.payPeriodPaymentNotes || "N/A"}</p>
                </div>
              </CardBody>
            </Card>
          ) : null
        ) : data?.paymentHistory ? (
          <Card>
            <CardHeader>
              {data?.paymentHistory ? "Payment History" : null}
            </CardHeader>
            <CardBody>
              {/*  payment history array of objects */}
              {data?.paymentHistory &&
                data?.paymentHistory?.map((item) => (
                  <>
                    {!item?.notes?.length ? (
                      // this is create after agent website redesign
                      // check if new structure
                      // check if website closing
                      // check if free booking website closing
                      item?.isNewStructure &&
                      (data?._closing?.isAgentWebsiteClosing ||
                        data?._closing?.isFreeBookingWebsiteClosing) ? (
                        <>{_createPaymentHistoryNote(item)}</>
                      ) : (
                        <p style={{ color: "#1B2430", marginBottom: 5 }}>
                          {" "}
                          ${item.paymentAmount} was paid{" "}
                          {item?.referenceNumber
                            ? "via check# " + item?.referenceNumber + " "
                            : null}
                          {item?.checkDate ? "on" : null}{" "}
                          {formatDateMomentMonthFirst(item.checkDate)}
                        </p>
                      )
                    ) : // this is create after agent website redesign
                    // check if new structure
                    // check if website closing
                    // check if free booking website closing
                    item?.isNewStructure &&
                      (data?._closing?.isAgentWebsiteClosing ||
                        data?._closing?.isFreeBookingWebsiteClosing) ? (
                      <>{_createPaymentHistoryNote(item)}</>
                    ) : (
                      <>
                        {/* both condition handled if "and" text found or not */}
                        <p>
                          ${item.paymentAmount} was{" "}
                          {item?.notes?.includes("and")
                            ? item.notes.split("and")[0]
                            : item.notes}
                        </p>
                        {item?.notes?.includes("and") && (
                          <p>{item.notes.split("and")[1]}</p>
                        )}
                      </>
                    )}
                  </>
                ))}
            </CardBody>
          </Card>
        ) : null}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" size="lg" outline onClick={_closeModal}>
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={loading}
          size="lg"
          onClick={_onSaveNotes}
        >
          {loading ? <i className="fa fa-spinner fa-spin mr-2" /> : null} Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddNotesModal;
